<template>
  <svg width="15" height="15" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.956496 12.999L0 13.9555L0.870415 14.8259L2.6964 12.9999H2.698L11.698 3.99991H11.6964L14.3789 1.31738L13.5085 0.44696L9.95557 3.99991H8.29044L6.98288 1.99991H0V3.99991V5.08969V11.9999C0 12.5376 0.424394 12.9762 0.956496 12.999ZM14 12.9999H4.43883L13.4388 3.99991H14C14.5523 3.99991 15 4.44762 15 4.99991V11.9999C15 12.5522 14.5523 12.9999 14 12.9999Z" fill="currentColor"/>
  </svg>
</template>

<script>
export default {
name: "IconFolderCross"
}
</script>